export default "__VITE_ASSET__BLZ1gE7a__"